import { DateTime } from 'luxon';
import { FlyerDetailsViewData } from './flyers';

export const getMerchantName = (locale: string, merchant) => {
  const lang = locale === 'fr-ca' ? 'fr' : 'en';
  return merchant && merchant.translations ? merchant.translations[lang].display_name : '';
};

export const getLocaledTime = (time: string, locale: string) => {
  const ts = parseInt(time);
  return DateTime.fromMillis(ts).setLocale(locale).toLocaleString(DateTime.DATE_FULL);
};

export const getValidity = (flyerData: FlyerDetailsViewData, locale: string) => {
  const from = getLocaledTime(flyerData.flyer.available_from, locale);
  const to = getLocaledTime(flyerData.flyer.available_to, locale);
  return `Valid ${from} to ${to}`;
};
